import $ from 'jquery';
import {debounce} from '../utils';

class AnnotationsWidget {
    constructor() {
        this.annotationWidgets = [];
        this.initializeWidgets();
        this.recalcAnnotationsWidget();
        this.overlappingAnnotationWidget();
    }

    initializeWidgets() {
        const annotations = $('.annotations-content-mark');
        if (!annotations.length) return;

        annotations.each((index, el) => {
            const $el = $(el);
            const heading = $el.data('headline');
            const text = $el.data('text');
            const url = $el.data('url');
            
            if ($el.parent().hasClass('wp-content')) {
                $el.wrap('<div/>');
            }
            
            const parent = $el.parent();
            const wrap = $('<div/>').addClass('relative');
            const inner = $('<div/>').addClass('annotations-widget');

            if (heading) {
                const elHeading = $('<span/>').addClass('listen').html(`${heading}`);
                inner.append(elHeading);
            }

            if (text) {
                const textContent = url ? `<a href="${url}">${text}</a>` : `<span>${text}</span>`;
                const elText = $('<div/>').addClass('info').html(`<p>${textContent}</p>`);
                inner.append(elText);
            }

            parent.wrap(wrap);
            inner.appendTo(parent.parent());
            this.annotationWidgets.push(inner);
        });

        if (typeof MktoForms2 !== 'undefined') {
            MktoForms2.whenReady(
                debounce(() => {
                    this.recalcAnnotationsWidget();
                }, 100)
            );
        }
    }

    recalcAnnotationsWidget() {
        if(!this.annotationWidgets.length) return;

        const wrapper = $('.aside-col.right');
        const wrapperOffset = wrapper.offset().top;
        const children = wrapper.children(':not(.item-center)');
        let busyArea = 0;

        children.each((index, el) => {
            busyArea += ($(el).offset().top + $(el).outerHeight()) - wrapperOffset;
        });

        this.annotationWidgets.forEach((el, index) => {
            $(el).css('top', '');
            const delta = (busyArea + wrapperOffset) - $(el).offset().top;
            if (delta > 0) {
                $(el).css('top', delta + 'px');
                busyArea = busyArea + $(el).outerHeight();
            }
        });

        this.annotationWidgets.sort((a, b) => {
            return $(a).offset().top - $(b).offset().top;
        })

        this.annotationWidgets.forEach((el, index) => {
            const prev = this.annotationWidgets[index - 1];
            if (prev) {
                const delta = $(prev).offset().top + $(prev).outerHeight() - $(el).offset().top;
                if (delta > 0) {
                    $(el).css('top', delta + 'px');
                }
            }
        })
    }


    overlappingAnnotationWidget() {
        const wrapper = $('.item-center');
        const children = wrapper.children();
        const widgetLoc = [];

        if (!wrapper.length || !children.length || !this.annotationWidgets.length) return false;

        this.annotationWidgets.forEach((el) => {
            let start = $(el).offset().top;
            let end = start + $(el).outerHeight();
            widgetLoc.push({ start, end });
        });

        const hideAtOverlapping = () => {
            children.each((i, childItem) => {
                const margin = 10;
                let start = $(childItem).offset().top - margin;
                let end = start + $(childItem).outerHeight() + margin;
                let isOverlapping = widgetLoc.some(el => el.end >= start && el.start <= end);

                $(childItem).toggleClass('annotation-overlapping', isOverlapping);
            });
        };

        hideAtOverlapping();
        document.addEventListener('scroll', hideAtOverlapping);
        window.addEventListener('resize', debounce(hideAtOverlapping, 500));
    }
}

export default AnnotationsWidget;
